.box {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 24px;
  background: var(--private);
  color: var(--private-ink);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;
}

.lock {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  background-color: currentColor;
  -webkit-mask: url('./lock.svg') no-repeat center / contain;
  mask: url('./lock.svg') no-repeat center / contain;
}

.points {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0 0 0 20px;
  font-size: 16px;
  line-height: 1.55;
}
